const STORAGE_KEY = 'safeguardpro_license';

const DEFAULT_LICENSE = {
  serialKey: '',
  updated_by: '',
  updated_at: ''
};

const readLicense = () => {
  if (typeof window === 'undefined') return { ...DEFAULT_LICENSE };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_LICENSE };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_LICENSE, ...parsed };
  } catch (error) {
    return { ...DEFAULT_LICENSE };
  }
};

const writeLicense = (license) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(license));
};

export default class LicenseService {
  get() {
    return readLicense();
  }

  save(license, user) {
    const next = {
      ...readLicense(),
      ...license,
      updated_by: user?.name || user?.id || 'system',
      updated_at: new Date().toISOString()
    };
    writeLicense(next);
    return next;
  }
}
